import { DragAndDropWrapper } from './DragAndDropWrapper';
import { withMaxItems } from './withMaxItems';
import { withReactToItemsChange } from './withReactToItemsChange';
import uuid from 'uuid/v4';

const ComponentWithMaxItems = withMaxItems(DragAndDropWrapper, uuid);
const ComponentWithReactToItemsChange = withReactToItemsChange(
  ComponentWithMaxItems
);

export const ListManager = ComponentWithReactToItemsChange;
